import React from 'react';
import Widgetv1 from './components/widget/WidgetController';
import Widgetv2 from './components/widgetv2/WidgetController';
import Widgetv3 from './components/widgetv3/WidgetController';
import HTTPService from './services/HTTP.service';
import SetupWidgetService from './services/SetupWidget.service';
import PartnerService from './services/Partner.service';

function App() {
	// switch widgets if necessary
	const settings = SetupWidgetService.getSetup(PartnerService.getPartnerId());
	let SelectedWidget = Widgetv1;
	if (settings.widgetVersion === 2) SelectedWidget = Widgetv2;
	if (settings.widgetVersion === 3) SelectedWidget = Widgetv3;

	return (
		<div className="App">
			<SelectedWidget apiUrl={HTTPService.getURLForService('api')} />
		</div>
	);
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js